export const PRELEAD_LIST_FILTER_CONFIG = {
  all: {
    label: 'All',
    query: {}
  },
  qualified: {
    label: 'Qualified',
    query: { converted_to_lead: true }
  },
  unqualified: {
    label: 'Unqualified',
    query: { is_disqualified: true }
  },
  // Same definition as Pending Telecalling card (interested, not converted, not disqualified).
  'pending-action': {
    label: 'Pending action',
    query: { state: 'interested', converted_to_lead: false, is_disqualified: false }
  },
  interested: {
    label: 'Interested',
    query: { state: 'interested' }
  },
  awaiting: {
    label: 'Awaiting response',
    query: { state: 'pending' }
  },
  'not-interested': {
    label: 'Not interested',
    query: { state: 'not_interested' }
  }
};

export const PRELEAD_LIST_FILTER_TABS = Object.entries(PRELEAD_LIST_FILTER_CONFIG).map(([id, config]) => ({
  id,
  label: config.label
}));

export function normalizePreleadListFilter(value) {
  const raw = String(value ?? '').trim();
  if (!raw || raw === 'all') return 'all';
  return PRELEAD_LIST_FILTER_CONFIG[raw] ? raw : 'all';
}

export function getPreleadListFilterQuery(filterId) {
  const id = normalizePreleadListFilter(filterId);
  return PRELEAD_LIST_FILTER_CONFIG[id]?.query ?? {};
}
